import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/instructions/bulk_adjust_stations_1.png'
import _imports_1 from '@/assets/instructions/bulk_adjust_stations_2.png'


const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_3 = {
  class: "ds-text-regular mt-2 mb-2",
  style: {"width":"500px"}
}
const _hoisted_4 = { class: "d-flex flex-row align-center pt-4" }
const _hoisted_5 = { class: "text-small pl-4" }
const _hoisted_6 = { class: "d-flex flex-row align-center pt-4" }
const _hoisted_7 = { class: "text-small pl-4" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FileInput = _resolveComponent("FileInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Station adjustment", -1)),
    (_ctx.stationAdjustmentAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "" }, "Actions", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                title: "Export template xslx-file",
                id: "test-id-export-station-adjustment-template",
                onClick: _ctx.exportStationAdjustmentTemplate
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" EXPORT TEMPLATE FOR STATION ADJUSTMENT ", -1)
                ])),
                _: 1,
                __: [0]
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_FileInput, {
                labelText: 'IMPORT STATION ADJUSTMENT',
                customClasses: 'el-button el-button--primary',
                title: 'Select xlsx-file',
                onFileSelected: _ctx.importStationAdjustmentXlsx,
                accept: '.xlsx',
                idTag: 'layout-xlsx-import-button'
              }, null, 8, ["onFileSelected"]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.importedXlsxName), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FileInput, {
                labelText: 'IMPORT LAYOUT FILE',
                customClasses: 'el-button el-button--primary',
                title: 'Select layf-file',
                onFileSelected: _ctx.importLayoutLayf,
                accept: '.layf',
                idTag: 'layout-layf-import-button'
              }, null, 8, ["onFileSelected"]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.importedLayfName), 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                disabled: _ctx.importedXlsxName === '' || _ctx.importedLayfName === '',
                title: _ctx.importedXlsxName === '' || _ctx.importedLayfName === '' ? 'Select file(s) first' : '',
                id: "test-id-send-station-adjustment",
                type: "primary",
                class: "mt-5",
                loading: _ctx.stationAdjustmentSent,
                onClick: _ctx.sendStationAdjustmentData
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" ADJUST STATIONS ", -1)
                ])),
                _: 1,
                __: [1]
              }, 8, ["disabled", "title", "loading", "onClick"])
            ])
          ]),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"ds-text-regular mt-2 mb-2 pr-5 pl-5\" style=\"width:600px;\"><h2>Instructions</h2><p> 1) Click <i>EXPORT TEMPLATE FOR STATION ADJUSTMENT</i> button to download a xlsx-file with correct column headers. This is not mandatory, but it is recommended way to ensure that the column headers are correct. </p><div> 2) Insert wanted adjustments into xlsx-file. <ul><li>Insert Station ID.</li><li>Insert wanted depth adjustment (insert 0 or leave empty, if not needed). This will move the station and the point where the station is located. Negative adjustment will move the station deeper and positive adjustment will move the station forward.</li><li>Insert wanted sideways adjustment (insert 0 or leave empty, if not needed) and amount of in and out segments that are wanted to be moved (default value of 2 is used, if empty). Negative adjustment will move the station and segments to the right (relatively to the station&#39;s point orientation) and positive adjustment will move the station and segments to the left (relatively to the station&#39;s point orientation).</li></ul><img src=\"" + _imports_0 + "\"><br><br><img src=\"" + _imports_1 + "\"></div><p> 3) Save changes to xlsx. </p><p> 4) Click <i>IMPORT STATION ADJUSTMENT</i>, select the xlsx and click <i>Open</i>. </p><p> 5) Click <i>IMPORT LAYOUT FILE</i>, select the layf file you want to adjust and click <i>Open</i>. </p><p> 6) Click <i>ADJUST STATIONS</i>. </p><p> 7) When adjustment is done, zip package containing the modified layf file and change log will be downloaded automatically. </p></div>", 1))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[4] || (_cache[4] = [
          _createElementVNode("p", null, "You do not have access rights to bulk adjustment feature.", -1)
        ])))
  ]))
}